"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _reactRedux = require("react-redux");
var _weirDls = require("@weirgroup/weir-dls");
var _main = _interopRequireDefault(require("./main"));
var _applicationRoutes = require("../../shared/_constants/applicationRoutes.constants");
var _oneWeir = require("@weirgroup/one-weir");
require("../../resources/styles/ReactToastify.css");
var _index = require("../../WLoadingImage/index");
var _constants = require("./constants");
var _manageYourTeam = require("./manageYourTeam.action");
var _mainModule = _interopRequireDefault(require("./main.module.css"));
class ManageYourTeamPage extends _react.default.Component {
  constructor(props) {
    super(props);
    _constants.applicationConstants.handleProgressAction = this.props.handleProgressAction;
  }
  componentDidMount() {
    let siteLabel = {};
    const allowedOption = Object.keys(_constants.mineSiteLabelOptions).includes(this.props.mineSiteLabel);
    if (allowedOption) {
      siteLabel = {
        singular: this.props.mineSiteLabel,
        plural: _constants.mineSiteLabelOptions[this.props.mineSiteLabel]
      };
      this.props.saveMineSiteLabel(siteLabel);
    }
  }
  componentDidUpdate(previousProps) {
    const {
      manageYourTeam,
      hideNotification
    } = this.props;
    // hide notification automatically after 10 seconds
    if (previousProps.manageYourTeam.showNotification !== manageYourTeam.showNotification && manageYourTeam.showNotification) {
      setTimeout(() => {
        if (manageYourTeam.showNotification) {
          hideNotification();
          manageYourTeam.onClose && manageYourTeam.onClose();
        }
      }, 10000);
    }
  }
  render() {
    const {
      loader,
      manageYourTeam,
      hideNotification
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_oneWeir.Toast, null), manageYourTeam && manageYourTeam.showNotification && /*#__PURE__*/_react.default.createElement("div", {
      className: _mainModule.default.notification
    }, /*#__PURE__*/_react.default.createElement(_weirDls.Notification, {
      variant: manageYourTeam.notificationType,
      title: manageYourTeam.notificationTitle,
      onClose: () => {
        hideNotification();
        manageYourTeam.onClose && manageYourTeam.onClose();
      },
      textContent: manageYourTeam.notificationMessage,
      callToActionList: manageYourTeam.callToActionList
    })), this.props.handleProgressAction ? /*#__PURE__*/_react.default.createElement(_index.WLoadingImage, {
      isLoading: loader !== undefined ? loader.loading : false
    }) : null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Router, {
      history: this.props.history
    }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
      exact: true,
      path: "".concat(this.props.appName).concat(_applicationRoutes.applicationRouteConstants.MANAGEYOUR_TEAM_PAGE),
      render: props => /*#__PURE__*/_react.default.createElement(_main.default, (0, _extends2.default)({}, props, {
        handleProgressAction: this.props.handleProgressAction,
        applicationID: this.props.applicationID,
        appName: this.props.appName,
        sourceSystemName: this.props.sourceSystemName
      }))
    }))));
  }
}
function mapStateToProps(state) {
  const {
    loader,
    manageYourTeam
  } = state;
  return {
    loader,
    manageYourTeam
  };
}
function mapDispatchToProps(dispatch) {
  return {
    hideNotification: () => {
      dispatch(_manageYourTeam.notificationActions.hideNotification());
    },
    saveMineSiteLabel: data => {
      dispatch((0, _manageYourTeam.saveMineSiteLabel)(data));
    }
  };
}
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ManageYourTeamPage);
ManageYourTeamPage.propTypes = {
  mineSiteLabel: _propTypes.default.oneOf(['Mine Site', 'Company'])
};
ManageYourTeamPage.defaultProps = {
  mineSiteLabel: 'Mine Site'
};